
<div v-if="value">
    <d-recipients-edit
        v-model       = "edit"
        :recipient-id = "company.id"
        :customer-id  = "company.parent.id"
        @saved        = "onSaved"
    />

    <c-list-card
        :icon            = "icon"
        :edit            = "enableEdit"
        :drag-data       = "value"
        :highlight-color = "highlightColor"
       :background       = "background"
        :drag-type       = "dragData"
        @edit            = "onEdit"
        @selected        = "onSelect"
    >
        <template v-slot:title>
            <div class="w-100 v-flex">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <div
                            v-bind = "attrs"
                            v-on   = "on"
                            class  = "card-title"
                        >
                            {{ value.id }} - {{ value.name }}
                        </div>
                    </template>
                    <div>
                        {{ value.id }} - {{ value.name }}
                    </div>
                </v-tooltip>
            </div>
        </template>

        <template v-slot:toolbar>
            <slot name="toolbar"></slot>
        </template>
        <template v-slot:body>
            <div>
                <v-row class="no-frame mt-1">
                    <v-col class="no-frame">
                        <div
                            class  = "card-name"
                            v-html = "toHtml (value.nameAdd)"
                            v-if   = "value.nameAdd"
                        />
                        <div class="card-subtitle">
                            {{ value.street }}
                        </div>
                        <div class="card-subtitle">
                            {{ value.zip }}  {{ value.city }}
                        </div>
                    </v-col>
                    <v-col class="no-frame col-auto">
                        <div v-if="value.dtype === 5" class="mt-1">
                            <c-tag
                                :width            = "tagwidth"
                                :background-color = "highlightColor"
                                :label            = "$t('msd.recipient.limshort')"
                                :active           = "value.liftmanagement"
                            />
                            <c-tag
                                :width            = "tagwidth"
                                :background-color = "highlightColor"
                                :label            = "$t('msd.recipient.incmanagement')"
                                :active           = "value.incidentmanagement"
                            />
                            <c-tag
                                :width            = "tagwidth"
                                :background-color = "highlightColor"
                                :label            = "$t('msd.recipient.incident')"
                                :active           = "value.usedOnIncidents"
                                class             = "mr-1"
                            />
                            <c-tag
                                :width            = "tagwidth"
                                :background-color = "highlightColor"
                                :label            = "$t('msd.recipient.costs')"
                                :active           = "value.usedOnCosts"
                                class             = "mr-1"
                            />
                            <c-tag
                                :width            = "tagwidth"
                                :background-color = "highlightColor"
                                :label            = "$t('msd.recipient.repair')"
                                :active           = "value.usedOnRepair"
                                class             = "mr-1"
                            />
                        </div>
                    </v-col>
                </v-row>
            </div>
        </template>
    </c-list-card>
</div>
